<template>
  <v-layout>
    <v-dialog v-model="showDialogItem" persistent max-width="600">
      <v-card>
        <v-toolbar color="white" class="elevation-1">
          <v-toolbar-title class="black--text font-weight-light">{{titleComponent}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="loading" flat color="error" icon round @click.native="cancelNewItem()">
              <v-icon large color="error">clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

          <v-layout justify-space-between wrap>
            <v-flex xs12 py-0>
              <v-autocomplete :items="utensils" box item-text="description" v-model="utensil"
                label="Descrição / Especificação" return-object></v-autocomplete>
            </v-flex>
            <v-flex xs12 py-0>
              <v-text-field box v-model="utensil.unity" label="Unidade" title="Unidade" disabled></v-text-field>
            </v-flex>
            <v-flex xs12 py-0>
              <v-text-field v-model="utensil.quantity" label="Quantidade" box></v-text-field>
            </v-flex>
            <!--  <v-flex xs12 md2 py-0>
                <v-text-field box v-model="utensil.lifetime" :label="labelDepreciation"></v-text-field>
              </v-flex> -->
            <v-flex xs12 py-0>
              <v-text-field v-model.lazy="utensil.value" label="Valor Unitário (R$)" box></v-text-field>
            </v-flex>
            <!--  <v-flex xs12 md2 offset-md10 py-0>
                <v-btn color="success lighten-1"  large @click.stop.prevent="save();" block>Salvar</v-btn>
              </v-flex> -->
          </v-layout>

        </v-card-text>
        <v-card-actions class="pb-3">
          <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1" @click.native="save();">
            Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import ProductService from "../../../service/ProductService.js";
  export default {

    data() {
      return {
        loading: false,
        showDialogItem: false,
        edit:false,
        utensil: {},
        utensils: []
      }
    },
    methods: {
      addNewItem() {
        this.initialize()
        this.showDialogItem = true
      },
      cancelNewItem() {
        this.utensil = {};
        this.utensils = [];
        this.showDialogItem = false;
      },
      save() {
        this.$emit('addUtensil', this.utensil)
        this.showDialogItem = false;
      },
      editItem(item) {
        this.utensil = item;
        this.edit = true;
        this.showDialogItem = true
      },
      async initialize() {
        this.loading = true;
        try {
          this.utensil = Object.assign({});
          this.utensils = await ProductService.getByCategory({
            type: "Utensílio"
          });
          this.edit = false
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false
        }
      },
    },
    computed: {
      titleComponent() {
        return this.edit ? "Editar Item" : "Novo Item"
      }
    }
  }

</script>
S



// WEBPACK FOOTER //
// src/components/contract/dialogs/DialogUtensil.vue